import projection from '../generated/pwm203f1.json';
import { AcceptanceManifest } from '../types';

export const pwm203f1AcceptanceManifest = projection as AcceptanceManifest;
